import { type InferType } from "yup";
import { EftAccountDetailsInputSchema } from "./AccountDetails/constants";
import { EftBankDetailsInputSchema } from "./BankDetails/constants";

export const EftPaymentPrefInputSchema = EftBankDetailsInputSchema.concat(
  EftAccountDetailsInputSchema,
);

export type EftPaymentPrefInputType = InferType<typeof EftPaymentPrefInputSchema>;
